<template>
  <div v-if="src" class="pl-overlay" @click.self="$emit('close')" @keydown.esc="$emit('close')">
    <button class="pl-close" @click="$emit('close')" title="Close (Esc)">✕</button>
    <div class="pl-frame" @click.stop>
      <img :src="src" :alt="alt || ''" />
      <div v-if="caption" class="pl-caption">{{ caption }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoLightbox',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    caption: { type: String, default: '' },
  },
  emits: ['close'],
  mounted() { document.addEventListener('keydown', this.onKey); },
  beforeUnmount() { document.removeEventListener('keydown', this.onKey); },
  methods: {
    onKey(e) { if (e.key === 'Escape' && this.src) this.$emit('close'); },
  },
};
</script>

<style scoped>
.pl-overlay{position:fixed;inset:0;background:rgba(5,10,20,.92);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;z-index:1100;padding:30px;animation:fadeIn .15s ease-out;}
.pl-close{position:fixed;top:20px;right:24px;background:rgba(15,35,71,.9);border:1px solid #1A3A6A;color:#E8EDF4;width:40px;height:40px;border-radius:50%;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;transition:.15s;}
.pl-close:hover{background:#1A3A6A;color:#4FC3F7;border-color:#4FC3F7;}
.pl-frame{max-width:90vw;max-height:90vh;display:flex;flex-direction:column;gap:12px;align-items:center;}
.pl-frame img{max-width:100%;max-height:80vh;border-radius:12px;box-shadow:0 24px 60px rgba(0,0,0,.6);object-fit:contain;background:#0A1628;}
.pl-caption{color:#E8EDF4;font-size:15px;font-weight:600;text-align:center;letter-spacing:.3px;}
@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}
</style>
